export type CalculateTourEnv = {
  general: CalculateTourGeneralEnv;
};

export type CalculateTourGeneralEnv = {
  scoreLetter: string;
  score: number;
  maxScore: number;
  topics: {
    COMMUNICATION: {
      score: number;
      maxScore: number;
      sections: {
        DIGITAL_COMMUNICATION: { score: number; maxScore: number };
        PHYSICAL_COMMUNICATION: { score: number; maxScore: number };
      };
    };
    FOOD_BEVERAGES: {
      score: number;
      maxScore: number;
      sections: {
        CATERING: { score: number; maxScore: number };
        DISHES: { score: number; maxScore: number };
      };
    };
    PUBLIC_ENGAGEMENT: {
      score: number;
      maxScore: number;
      sections: {
        PUBLIC_INFORMATION: { score: number; maxScore: number };
        PARTNERSHIP_STRATEGY: { score: number; maxScore: number };
      };
    };
    RESOURCES_POLLUTION: {
      score: number;
      maxScore: number;
      sections: {
        WATER_AND_WASTE: { score: number; maxScore: number };
      };
    };
    EQUIPMENT_AND_SCENOGRAPHY: {
      score: number;
      maxScore: number;
      sections: {
        SCENOGRAPHY: { score: number; maxScore: number };
        TECHNIQUE: { score: number; maxScore: number };
      };
    };
  };
};

export const EMPTY_CALCULATE_TOUR_ENV: CalculateTourEnv = {
  general: {
    scoreLetter: '',
    score: 0,
    maxScore: 0,
    topics: {
      COMMUNICATION: {
        score: 0,
        maxScore: 0,
        sections: {
          DIGITAL_COMMUNICATION: { score: 0, maxScore: 0 },
          PHYSICAL_COMMUNICATION: { score: 0, maxScore: 0 },
        },
      },
      FOOD_BEVERAGES: {
        score: 0,
        maxScore: 0,
        sections: {
          CATERING: { score: 0, maxScore: 0 },
          DISHES: { score: 0, maxScore: 0 },
        },
      },
      PUBLIC_ENGAGEMENT: {
        score: 0,
        maxScore: 0,
        sections: {
          PUBLIC_INFORMATION: { score: 0, maxScore: 0 },
          PARTNERSHIP_STRATEGY: { score: 0, maxScore: 0 },
        },
      },
      RESOURCES_POLLUTION: {
        score: 0,
        maxScore: 0,
        sections: {
          WATER_AND_WASTE: { score: 0, maxScore: 0 },
        },
      },
      EQUIPMENT_AND_SCENOGRAPHY: {
        score: 0,
        maxScore: 0,
        sections: {
          SCENOGRAPHY: { score: 0, maxScore: 0 },
          TECHNIQUE: { score: 0, maxScore: 0 },
        },
      },
    },
  },
};
